import { isNil } from 'lodash';

import { CountryModel } from 'models';

import { countriesStore } from 'stores';

function getCountryByLocation(location?: LocationType): CountryModel | undefined {
  if (!location) {
    return undefined;
  }

  return countriesStore.modelValues.find((country) => country.value.alpha_2_code === location.country_code);
}

function getCountryIdByName(name: string): CountryModel | undefined {
  if (!name) {
    return undefined;
  }

  return countriesStore.modelValues.find((country) => country.name === name);
}

function getCountryCodeById(id?: number | nil): string | undefined {
  if (isNil(id)) {
    return undefined;
  }

  return countriesStore.findById(id)?.alpha_2_code?.toLowerCase();
}

export { getCountryByLocation, getCountryIdByName, getCountryCodeById };
